import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SymbolIcon = (props: SvgProps) => (
  <Svg
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      fill="#BDBDBD"
      d="M7.04 15.776c-4.104 0-6.672-2.472-6.672-6.504 0-5.736 3.84-9.168 9.024-9.168 4.488 0 6.744 2.544 6.744 6.504 0 2.784-1.032 5.616-3.624 5.616-1.728 0-2.592-1.056-2.4-2.856-.432 1.44-1.344 2.76-3.216 2.76-1.8 0-2.88-1.32-2.88-3.36 0-3.096 1.824-5.016 3.936-5.016 1.608 0 2.568.984 2.52 2.808l.384-2.592H12.2l-.696 4.848c-.216 1.488.048 2.256 1.056 2.256 1.584 0 2.256-2.352 2.256-4.416 0-3.264-1.776-5.328-5.64-5.328-4.2 0-7.392 2.784-7.392 7.824 0 3.336 1.968 5.376 5.376 5.376 1.032 0 2.256-.288 3.024-.792l-.216 1.512c-.936.36-1.92.528-2.928.528ZM7.472 11c1.968 0 2.592-1.608 2.736-2.52l.12-.84c.264-1.872-.648-2.76-2.136-2.76-1.728 0-2.832 1.488-2.832 3.744 0 1.584.888 2.376 2.112 2.376Z"
    />
  </Svg>
)
export default SymbolIcon
